import { useQuery } from '@tanstack/react-query';
import { classQueries } from 'src/core/services/classes/queries';
export function useGetClasses({ enabled, classHashIds }) {
    return useQuery({
        ...classQueries.listClasses(classHashIds?.join(',')),
        enabled
    });
}
